import React, { useState, useEffect } from 'react';
import NavBar from './commonHooks/commonHooks.navBar';
import DataService from '../service/service.sql';
import './css/friends.css'; // Import the CSS file

const MyFriends = () => {
    const [receivedFriends, setReceivedFriends] = useState([]);
    const [sharedFriends, setSharedFriends] = useState([]);
    const [newFriendName, setNewFriendName] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const received = await DataService.friendsGetAllReceived();
            const shared = await DataService.friendsGetAllShared();
            setReceivedFriends(received.data.listOfFriends);
            setSharedFriends(shared.data.listOfFriends);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const removeSharedFriend = async (friend) => {
        const isConfirmed = window.confirm("Are you sure you want to remove this shared friend?");
        if (isConfirmed) {
            try {
                await DataService.friendsRemoveShared({ friendReceived: friend });
                fetchData();
            } catch (error) {
                console.error("Error removing shared friend:", error);
            }
        }
    };
    
    const removeReceivedFriend = async (friend) => {
        const isConfirmed = window.confirm("Are you sure you want to remove this received friend?");
        if (isConfirmed) {
            try {
                await DataService.friendsRemoveReceived({ friendReceived: friend });
                fetchData();
            } catch (error) {
                console.error("Error removing received friend:", error);
            }
        }
    };

    const viewLogs = (friend) => {
        window.location.href = '/friendslogs?friend='+encodeURIComponent(friend);
    };

    const addFriend = async () => {
        try {
            await DataService.friendsCreate({ friendReceived: newFriendName });
            setNewFriendName('');
            fetchData();
        } catch (error) {
            console.error("Error adding friend:", error);
        }
    };

    return (
        <div>
            <NavBar />
            <div className='friends-container'>
                <h2>Share Logs To:</h2>
                <div>
                    <input
                        type="text"
                        value={newFriendName}
                        onChange={(e) => setNewFriendName(e.target.value)}
                        placeholder="Enter friend's username"
                    />
                    <button onClick={addFriend}>Share Your Logs</button>
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                        <h2>Received Logs From:</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>Friend</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {receivedFriends.map((friend, index) => (
                                    <tr key={index}>
                                        <td>{friend.friendSharedUser}</td>
                                        <td>
                                            <button onClick={() => removeReceivedFriend(friend.friendSharedUser)}>Remove</button>
                                            <button onClick={() => viewLogs(friend.friendSharedUser)}>View Logs</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div style={{ flex: 1 }}>
                        <h2>Shared Logs To:</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>Friend</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sharedFriends.map((friend, index) => (
                                    <tr key={index}>
                                        <td>{friend.friendReceivedUser}</td>
                                        <td>
                                            <button onClick={() => removeSharedFriend(friend.friendReceivedUser)}>Remove</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyFriends;
